/* Indirizzo di spedizione nel carrello: stato "compilato" con recap compatto
   + apertura/chiusura, barra totale sticky su mobile.
   Gli id dei campi restano quelli letti da cart.js. */
(function(){
  var box = document.getElementById('cart-shipping-box');
  if(!box) return;
  var form = document.getElementById('ship-form');
  var recap = document.getElementById('ship-recap');
  var editBtn = document.getElementById('ship-edit');
  var confirmBtn = document.getElementById('ship-confirm');
  var note = document.getElementById('cart-shipping-note');
  var copy = document.getElementById('cart-shipping-copy');
  var F = {
    email: 'ship-email', phone: 'ship-phone', firstName: 'ship-first-name', lastName: 'ship-last-name',
    company: 'ship-company', address1: 'ship-address1', address2: 'ship-address2',
    zip: 'ship-zip', city: 'ship-city', provinceCode: 'ship-province', countryCode: 'ship-country'
  };
  var marketingEl = document.getElementById('ship-marketing');
  function el(k){ return document.getElementById(F[k]); }
  function val(k){ var e = el(k); return e && typeof e.value === 'string' ? e.value.trim() : ''; }
  function data(){ var o = {}; Object.keys(F).forEach(function(k){ o[k] = val(k); }); return o; }

  var REQ = ['email','phone','firstName','lastName','address1','zip','city','countryCode'];
  function complete(){
    var d = data();
    if(!REQ.every(function(k){ return !!d[k]; })) return false;
    if(!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(d.email)) return false;
    if(d.phone.replace(/\D/g,'').length < 6) return false;
    if(d.countryCode.toUpperCase() === 'IT' && !d.provinceCode) return false;
    return true;
  }

  function countryLabel(){
    var e = el('countryCode');
    if(e && e.tagName === 'SELECT' && e.selectedIndex >= 0) return e.options[e.selectedIndex].textContent;
    return val('countryCode');
  }
  function renderRecap(){
    var d = data();
    var who = [d.firstName, d.lastName].filter(Boolean).join(' ');
    var street = [d.address1, d.address2].filter(Boolean).join(' · ');
    var town = [d.zip, d.city].filter(Boolean).join(' ') + (d.provinceCode ? ' (' + d.provinceCode.toUpperCase() + ')' : '');
    recap.innerHTML = '<span class="msr rc-ok">check_circle</span><div class="rc-txt">'
      + '<b>' + esc(who) + (d.company ? ' <i>' + esc(d.company) + '</i>' : '') + '</b>'
      + '<span>' + esc(street) + '</span>'
      + '<span>' + esc(town) + ' · ' + esc(countryLabel()) + '</span>'
      + '<span class="rc-contact">' + esc(d.email) + ' · ' + esc(d.phone) + '</span>'
      + (marketingEl && marketingEl.checked ? '<span class="rc-marketing"><span class="msr">mark_email_read</span>Iscritto agli aggiornamenti WowSticker</span>' : '')
      + '</div>';
  }
  function esc(s){ return String(s == null ? '' : s).replace(/[&<>"]/g, function(c){ return {'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;'}[c]; }); }

  var asideShip = document.getElementById('aside-ship');
  var checkoutBtn = document.getElementById('cart-checkout');
  var barBtnEl = document.getElementById('cart-bar-btn');
  function focusShipping(){
    var y = box.getBoundingClientRect().top + window.pageYOffset - 90;
    window.scrollTo({ top: Math.max(0, y), behavior: (window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth') });
    var e = el('email'); if(e) setTimeout(function(){ e.focus({ preventScroll:true }); }, 320);
  }
  function syncCta(done){
    if(asideShip){
      asideShip.hidden = false;
      asideShip.className = 'aside-ship' + (done ? ' ok' : '');
      asideShip.innerHTML = done
        ? '<span class="msr">check_circle</span><span>Indirizzo confermato<i>Modifica</i></span>'
        : '<span class="msr">local_shipping</span><span>Manca l\'indirizzo di spedizione<i>Compila ora</i></span>';
    }
    var label = done ? 'Vai al pagamento <span class="ic">›</span>' : 'Aggiungi l\'indirizzo <span class="ic">›</span>';
    if(checkoutBtn){ checkoutBtn.innerHTML = label; checkoutBtn.dataset.label = label; }
    if(barBtnEl) barBtnEl.textContent = done ? 'Vai al pagamento' : 'Aggiungi l\'indirizzo';
  }
  if(asideShip) asideShip.addEventListener('click', function(){
    if(box.getAttribute('data-state') === 'done') setState('edit');
    focusShipping();
  });

  function setState(s){
    box.setAttribute('data-state', s);
    var done = s === 'done';
    syncCta(done);
    if(recap) recap.hidden = !done;
    if(form) form.hidden = done;
    if(editBtn) editBtn.hidden = !done;
    if(copy) copy.textContent = done
      ? 'Consegniamo a questo indirizzo. Puoi modificarlo prima del pagamento.'
      : 'Compili qui una volta: al pagamento trovi tutto già pronto.';
    if(done) renderRecap();
  }

  function tryConfirm(){
    if(!complete()){
      if(note){ note.hidden = false; note.textContent = 'Completa i campi obbligatori per continuare.'; }
      var missing = REQ.filter(function(k){ return !val(k); })[0];
      var target = el(missing || 'email');
      if(target) target.focus();
      return false;
    }
    if(note){ note.hidden = true; note.textContent = ''; }
    setState('done');
    return true;
  }
  if(confirmBtn) confirmBtn.addEventListener('click', tryConfirm);
  if(editBtn) editBtn.addEventListener('click', function(){ setState('edit'); var e = el('email'); if(e) e.focus(); });

  /* se cart.js segnala un errore di validazione, riapriamo il form */
  if(note) new MutationObserver(function(){
    if(!note.hidden && box.getAttribute('data-state') === 'done') setState('edit');
  }).observe(note, { attributes:true, attributeFilter:['hidden'], childList:true });

  /* stato iniziale: se i dati sono già completi (login o dispositivo noto) resta compatto */
  setTimeout(function(){ setState(complete() ? 'done' : 'edit'); }, 0);

  /* il CTA principale non apre il pagamento se manca l'indirizzo */
  if(checkoutBtn) checkoutBtn.addEventListener('click', function(e){
    if(box.getAttribute('data-state') !== 'done'){
      e.stopImmediatePropagation(); e.preventDefault();
      focusShipping();
      if(!complete() && note){ note.hidden = false; note.textContent = 'Serve l\'indirizzo di spedizione per procedere al pagamento.'; }
    }
  }, true);

  /* ----- barra totale sticky (mobile) ----- */
  var bar = document.getElementById('cart-bar');
  var grid = document.getElementById('cart-grid');
  var total = document.getElementById('cart-total');
  var barTotal = document.getElementById('cart-bar-total');
  var barBtn = document.getElementById('cart-bar-btn');
  var checkout = document.getElementById('cart-checkout');
  if(bar && grid && total){
    function syncBar(){
      bar.hidden = !!grid.hidden;
      if(barTotal) barTotal.textContent = total.textContent;
    }
    new MutationObserver(syncBar).observe(grid, { attributes:true, attributeFilter:['hidden'] });
    new MutationObserver(syncBar).observe(total, { childList:true, characterData:true, subtree:true });
    document.addEventListener('wowcart:change', function(){ setTimeout(syncBar, 0); });
    syncBar();
  }
  if(barBtn && checkout) barBtn.addEventListener('click', function(){
    if(box.getAttribute('data-state') !== 'done'){ focusShipping(); return; }
    checkout.click();
  });
})();
